import { AnnouncementsView } from "../Views";

export const AnnouncementsPage = (props: { location: any }) => {
	return <AnnouncementsView location={props.location} />;
};
